import React, { useEffect } from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import './styles.scss';

const brainItems = [
  {
    title: 'Pre-Transmission EDI Intercept',
    body: 'Auto-clears 95% of standard lines. Routes complex anomalies (e.g., Chapter 88 aircraft parts, engineering assists) for manual override before hitting CBP ACE.',
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    color: 'sky',
  },
  {
    title: 'Post Summary Corrections (PSC)',
    body: 'Executes historical shadow audits to find overpayments and recover capital from U.S. Customs.',
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    color: 'sky',
  },
];

const muscleItems = [
  {
    title: 'TBML Defense & Liability Shielding',
    body: 'Generates an automated Cryptographic Audit Dossier to prove to CBP that the SWIFT settlement matches the Form 7501 declaration flawlessly.',
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    color: 'emerald',
  },
  {
    title: 'Automated Disbursement',
    body: 'When goods clear, the ledger auto-disburses freight to the forwarder, duties to CBP, fees to the broker, and final invoice to the factory.',
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    color: 'emerald',
  },
];

const EnginePanel = ({ engine, tag, title, body, items }) => (
  <Box className="ts-panel">
    <Typography className={`ts-panel__tag ts-panel__tag--${engine}`}>{tag}</Typography>
    <Typography variant="h2" className="ts-panel__title">{title}</Typography>
    <Typography className="ts-panel__body">{body}</Typography>
    <ul className="ts-feature-list">
      {items.map((item) => (
        <li key={item.title} className="ts-feature-list__item">
          <span className={`ts-feature-list__icon ts-feature-list__icon--${item.color}`}>
            {item.icon}
          </span>
          <div>
            <strong className="ts-feature-list__item-title">{item.title}</strong>
            <span className="ts-feature-list__item-body">{item.body}</span>
          </div>
        </li>
      ))}
    </ul>
  </Box>
);

const TradeSecurePage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box className="ts-page">
      {/* Header */}
      <Container maxWidth="lg">
        <Box className="ts-header">
          {/* <Box className="ts-header__pill">Global Trade Compliance OS</Box> */}
          <Typography variant="h1" className="ts-header__title">
            Defend the Audit.{' '}
            <span className="ts-header__accent">Automate the Settlement.</span>
          </Typography>
          <Typography className="ts-header__subtitle">
            Lusid Trade Secure unifies zero-hallucination semantic extraction with programmable MT103
            ledgers. We execute Form 28 audit defense and frictionless DDP/CIF management in a
            single workflow.
          </Typography>
        </Box>
      </Container>

      {/* Engine panels */}
      <Container maxWidth="xl" className="ts-panels">
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <EnginePanel
              engine="sky"
              tag="Engine 01"
              title='The Brain: Trade Compliance OS'
              body="An AI-driven semantic extraction engine that ingests unstructured commercial invoices, bills of lading, and 500-page BOMs. It performs line-level deterministic math against draft CBP Form 7501s to ensure absolute compliance with 19 CFR."
              items={brainItems}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <EnginePanel
              engine="sky"
              tag="Engine 02"
              title='The Muscle: Synchronized Settlement'
              body="A programmable financial ledger acting as a conditional allocation engine. Funds are staged for programmatic release and cannot be wired to the foreign supplier until The Brain clears the compliance audit."
              items={muscleItems}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default TradeSecurePage;